import { render, staticRenderFns } from "./Patrocinadores.vue?vue&type=template&id=281a2068&"
import script from "./Patrocinadores.vue?vue&type=script&lang=js&"
export * from "./Patrocinadores.vue?vue&type=script&lang=js&"
import style0 from "./Patrocinadores.vue?vue&type=style&index=0&id=281a2068&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports